import React from 'react';
import { Shirt } from 'lucide-react';
import PageHero from '../components/common/PageHero';
import GownRequestForm from '../components/gown/GownRequestForm';

const GownRequestPage = () => (
  <div className="bg-ink-50">
    <PageHero
      icon={Shirt}
      title="Request graduation gown"
      subtitle="Enter your admission number to request your graduation gown"
    />
    <GownRequestForm />
  </div>
);

export default GownRequestPage;
